<template>
  <div class="md:hidden flex space-x-[110px] place-content-center mx-6 ">
           <div class="block items-center">
             <svg
               xmlns="http://www.w3.org/2000/svg"
               fill="none"
               viewBox="0 0 24 24"
               stroke-width="1.5"
               stroke="#fff"
               class="w-7 h-7 cursor-pointer inline-block mb-1 ml-3"
               @click="$emit('showActions')"
             >
               <path
                 stroke-linecap="round"
                 stroke-linejoin="round"
                 d="M8.25 6.75h12M8.25 12h12m-12 5.25h12M3.75 6.75h.007v.008H3.75V6.75zm.375 0a.375.375 0 11-.75 0 .375.375 0 01.75 0zM3.75 12h.007v.008H3.75V12zm.375 0a.375.375 0 11-.75 0 .375.375 0 01.75 0zm-.375 5.25h.007v.008H3.75v-.008zm.375 0a.375.375 0 11-.75 0 .375.375 0 01.75 0z"
               />
             </svg>
             <span class="tab tab-kategori block text-sm text-white mt- mr-3"
               >المشغل</span
             >
           </div>
           <div>
             <svg
               xmlns="http://www.w3.org/2000/svg"
               fill="none"
               viewBox="0 0 24 24"
               stroke-width="1.5"
               stroke="#C43670"
               class="w-7 h-7 cursor-pointer inline-block mb-1"
               @click="$emit('showList')"
             >
               <path
                 stroke-linecap="round"
                 stroke-linejoin="round"
                 d="M8.25 6.75h12M8.25 12h12m-12 5.25h12M3.75 6.75h.007v.008H3.75V6.75zm.375 0a.375.375 0 11-.75 0 .375.375 0 01.75 0zM3.75 12h.007v.008H3.75V12zm.375 0a.375.375 0 11-.75 0 .375.375 0 01.75 0zm-.375 5.25h.007v.008H3.75v-.008zm.375 0a.375.375 0 11-.75 0 .375.375 0 01.75 0z"
               />
             </svg>
             <span class="tab tab-kategori block text-sm text-white mt-"
               >الأغاني</span
             >
           </div>
         </div>

</template>

<script>
export default {
emits:['showActions','showList']
}
</script>

<style>

</style>
